import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import ui from './redux/ui/reducers';
import cardReader from './redux/cardReader/reducers';
import sagas from './redux/sagas';

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
  ui,
  cardReader,
});

const middleware = applyMiddleware(sagaMiddleware);
const store = createStore(
  reducer,
  compose(
    middleware,
    window.devToolsExtension ? window.devToolsExtension() : (f) => f,
  ),
);

sagaMiddleware.run(sagas);

export default store;
